const mockedApplicationStats = [
  {
    area: {
      v: 1.8,
      u: 'ac'
    },
    averageYield: {
      v: 163,
      u: 'short-ton/ac'
    },
    label: 'Sprayer SD',
    applicationPassName: 'Sprayer SD',
    dateApplied: '2021-08-02T13:11:37.709Z',
    products: [
      'X-Cyte',
      '30-0-0 UAN'
    ],
    appliedYield: {
      averageMoisture: {
        v: 22.2,
        u: 'percent'
      },
      averageYield: {
        v: 163,
        u: 'short-ton/ac'
      },
      area: {
        v: 1.8,
        u: 'ac'
      }
    },
    unappliedYield: {
      averageMoisture: {
        v: 0.0,
        u: 'percent'
      },
      averageYield: {
        q: '0',
        u: 'short-ton/ac'
      },
      area: {
        v: 0.0,
        u: 'ac'
      }
    }
  }
]

export const regionReportDryYieldData = (withApplicationStats = false) => {
  const applicationStats = withApplicationStats ? { applicationStats : mockedApplicationStats } : {};
  return {
    data: {
      reports: {
        fieldRegionReport: {
          averageYield: {
            u: 'short-ton/ac',
            v: 149,
          },
          averageMoisture: {
            u: 'percent',
            v: 15.3,
          },
          acres: 71.04,
          area: {
            u: 'ac',
            v: 71.0,
          },
          label: 'FC 606 GSS',
          ...applicationStats,
          soilStats: [
            {
              averageYield: {
                u: 'short-ton/ac',
                v: 149,
              },
              averageMoisture: {
                u: 'percent',
                v: 15.3,
              },
              acres: 71.04,
              area: {
                u: 'ac',
                v: 71.0,
              },
              soilStats: [],
              hybridStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: 'FC 606 GSS',
                },
              ],
              seedTreatmentStats: [],
              elevationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '0.0 ft',
                },
              ],
              populationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '4537.0 k',
                },
              ],
              planterDateStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '04/03/19',
                },
              ],
              label: 'Hilton silt loam, 0 to 3 percent slopes',
              totalWeight: {
                v: 1.09,
                u: 'short-ton'
              },
            },
          ],
          hybridStats: [
            {
              averageYield: {
                u: 'short-ton/ac',
                v: 149,
              },
              averageMoisture: {
                u: 'percent',
                v: 15.3,
              },
              acres: 71.04,
              area: {
                u: 'ac',
                v: 71.0,
              },
              soilStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: 'Hilton silt loam, 0 to 3 percent slopes',
                },
              ],
              hybridStats: [],
              seedTreatmentStats: [],
              elevationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '0.0 ft',
                },
              ],
              populationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '4537.0 k',
                },
              ],
              planterDateStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '04/03/19',
                },
              ],
              label: 'FC 606 GSS',
              totalWeight: {
                v: 1.09,
                u: 'short-ton'
              },
            },
          ],
          seedTreatmentStats: [],
          elevationStats: [
            {
              averageYield: {
                u: 'short-ton/ac',
                v: 149,
              },
              averageMoisture: {
                u: 'percent',
                v: 15.3,
              },
              acres: 71.04,
              area: {
                u: 'ac',
                v: 71.0,
              },
              soilStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: 'Hilton silt loam, 0 to 3 percent slopes',
                },
              ],
              hybridStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    q: 71.04,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: 'FC 606 GSS',
                },
              ],
              seedTreatmentStats: [],
              elevationStats: [],
              populationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '4537.0 k',
                },
              ],
              planterDateStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '04/03/19',
                },
              ],
              label: '0.0 ft',
              totalWeight: {
                v: 1.09,
                u: 'short-ton'
              },
            },
          ],
          populationStats: [
            {
              averageYield: {
                u: 'short-ton/ac',
                v: 149,
              },
              averageMoisture: {
                u: 'percent',
                v: 15.3,
              },
              acres: 71.04,
              area: {
                u: 'ac',
                v: 71.0,
              },
              soilStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: 'Hilton silt loam, 0 to 3 percent slopes',
                },
              ],
              hybridStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: 'FC 606 GSS',
                },
              ],
              seedTreatmentStats: [],
              elevationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '0.0 ft',
                },
              ],
              populationStats: [],
              planterDateStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 71.04,
                  area: {
                    u: 'ac',
                    v: 71.0,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '04/03/19',
                },
              ],
              label: '4537.0 k',
              totalWeight: {
                v: 1.09,
                u: 'short-ton'
              },
            },
          ],
          planterDateStats: [
            {
              averageYield: {
                u: 'short-ton/ac',
                v: 149,
              },
              averageMoisture: {
                u: 'percent',
                v: 15.3,
              },
              acres: 71.04,
              area: {
                u: 'ac',
                v: 71.0,
              },
              soilStats: [],
              hybridStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: 'FC 606 GSS',
                },
              ],
              seedTreatmentStats: [],
              elevationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '0.0 ft',
                },
              ],
              populationStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '4537.0 k',
                },
              ],
              planterDateStats: [
                {
                  averageYield: {
                    u: 'short-ton/ac',
                    v: 149,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.3,
                  },
                  acres: 4.5826495479841025,
                  area: {
                    u: 'ac',
                    v: 4.6,
                  },
                  soilStats: [],
                  hybridStats: [],
                  seedTreatmentStats: [],
                  elevationStats: [],
                  populationStats: [],
                  planterDateStats: [],
                  label: '04/03/19',
                },
              ],
              label: '5/23/2023',
              totalWeight: {
                v: 1.09,
                u: 'short-ton'
              },
            },
          ],
          populationUnits: 'kg/ha',
          hybridColors: [
            {
              label: 'FC 606 GSS',
              color: '#b589ff'
            },
          ],
          totalWeight: {
            v: 1.09,
            u: 'short-ton'
          },
        },
      },
    },
  };
};
